import React from 'react';

import cls from './Layout.module.scss';

interface LayoutProps {
    header?: React.ReactNode;
    children?: React.ReactNode;
    footer?: React.ReactNode;
    bgImage?: string;
}

const Layout = ({header, children, footer, bgImage}: LayoutProps) => {

    //todo добавить определение челки от модели устройства
    const fringe = 0

    return (
        <div className={cls.layout} style={{backgroundImage: `url(${bgImage})`}}>

            <div style={{height: fringe}}/>

            {header}

            <div className={cls.content}>
                {children}
            </div>

            {footer}

        </div>
    )
}

export default Layout